import { StyleSheet } from "react-native"
import { colors, typography } from "theme"

export const style = StyleSheet.create({
  button: { marginBottom: 20 },
  buttonContainer: { alignItems: "center", flex: 1, justifyContent: "flex-end", marginBottom: 20 },
  cameraContainer: { alignItems: "center", justifyContent: "center" },
  container: { height: "100%", marginTop: 30, padding: 10 },
  containerWrapper: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 20,
  },
  dropdown: {
    backgroundColor: colors.inputFieldBackground,
    borderColor: colors.inputFieldBorder,
    borderRadius: 999,
    borderWidth: 1,
    flexDirection: "row",
    justifyContent: "center",
    marginBottom: 6,
    marginTop: 10,
    minHeight: 50,
    paddingRight: 10,
  },
  errorTextField: {
    borderColor: colors.error,
  },
  inputContainer: { alignSelf: "center", marginTop: 20 },
  inputStyle: {
    height: 50,
    paddingLeft: 10,
    paddingVertical: 10,
    width: "100%",
  },
  modalCloseButton: { color: colors.white, position: "absolute", right: 10, top: 10, zIndex: 1 },
  modalContainer: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
    maxWidth: 800,
    alignSelf: "center",
  },
  title: {
    fontFamily: typography.primary.normal,
    fontSize: 12,
    marginBottom: 6,
    paddingLeft: 4,
  },
  titleContainer: {
    backgroundColor: colors.white,
    left: 20,
    opacity: 1,
    position: "absolute",
    top: 2,
    zIndex: 9999,
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 23 },
})
